import { css, Paragraph, styled } from 'canoe';
import React from 'react';

import LoadSpinner from '!!react-svg-loader!./LoadSpinner.svg';

const LoadingContainer = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: ${theme.spaces.normal};
    border: 1px solid ${theme.colors.GlitterGrayL10};
    border-radius: ${theme.borderRadius.small};
  `}
`;

const Loading = styled.div`
  ${({ theme }) => css`
  position: relative;
  height: 86px;
  width: 86px;
  margin: ${theme.spaces.normal};
  margin-top: ${theme.spaces.none};
  animation: load 1s linear infinite;

  @keyframes load {
    100% {
      transform: rotate(360deg);
    }
`}
`;

export const LoadingContent = () => (
  <LoadingContainer>
    <Loading>
      <LoadSpinner />
    </Loading>
    <Paragraph color="OnyxGrayL30">Gathering & visualising your content ...</Paragraph>
  </LoadingContainer>
);
